'use strict';

(function app() {
    var tabletBreak = 1260;
    var mobileBreak = 768;
    var mobileXSBreak = 375;
    var offsetX = window.pageXOffset;
    var offsetY = window.pageYOffset;
    var isWindowFrozen = false;
    var isHeaderActive = false;

    // Base functions

    function detectBrowser() {
        var html = $('html');
        function init() {
            var userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.indexOf('chrome') > -1 && userAgent.indexOf('edg/') <= -1) {
                html.addClass('is-chrome');
            } else {
                html.removeClass('is-chrome');
            }
            if (
                userAgent.indexOf('safari') > -1
                && userAgent.indexOf('chrome') <= -1
            ) {
                html.addClass('is-safari');
            } else {
                html.removeClass('is-safari');
            }
            if (userAgent.indexOf('firefox') > -1) {
                html.addClass('is-firefox');
            } else {
                html.removeClass('is-firefox');
            }
            if (
                userAgent.indexOf('msie ') > -1
                || userAgent.indexOf('trident/') > -1
            ) {
                html.addClass('is-ie');
            } else {
                html.removeClass('is-ie');
            }
            if (userAgent.indexOf('edg/') > -1) {
                html.addClass('is-edge');
            } else {
                html.removeClass('is-edge');
            }
        }
        $(window).on('load resize', function onLoadWindow() {
            init();
        });
        init();
    }

    function detectDevice() {
        var html = $('html');
        function init() {
            var viewport = $('html head meta[name="viewport"]')[0];
            var userAgent = navigator.userAgent.toLowerCase();
            var orientation = window.matchMedia('(orientation: portrait)').matches;

            // System
            if (userAgent.indexOf('mac') > -1) {
                html.addClass('is-mac is-macos');
            } else {
                html.removeClass('is-mac is-macos');
            }
            if (userAgent.match(/(iphone|ipod|ipad)/)) {
                if (userAgent.match(/iphone/)) {
                    if (window.screen.width < mobileBreak && window.screen.width >= 390) {
                        html.addClass('is-iphone-12');
                    } else {
                        html.removeClass('is-iphone-12');
                    }
                    if (window.screen.width < mobileBreak && window.screen.width < 390) {
                        html.addClass('is-iphone-10');
                    } else {
                        html.removeClass('is-iphone-10');
                    }
                    if (window.screen.width < mobileBreak && window.screen.width < 375) {
                        html.addClass('is-iphone-5');
                    } else {
                        html.removeClass('is-iphone-5');
                    }
                    html.addClass('is-iphone');
                } else {
                    html.removeClass('is-iphone-12 is-iphone-10 is-iphone-5 is-iphone');
                }
                if (userAgent.match(/ipod/)) {
                    html.addClass('is-ipod');
                } else {
                    html.removeClass('is-ipod');
                }
                if (userAgent.match(/ipad/)) {
                    html.addClass('is-ipad');
                } else {
                    html.removeClass('is-ipad');
                }
                html.addClass('is-ios');
            } else {
                html.removeClass('is-phone is-ipod is-ipad is-ios');
            }
            if (userAgent.indexOf('android') > -1) {
                html.addClass('is-android');
            } else {
                html.removeClass('is-android');
            }

            // Type
            if (
                navigator.maxTouchPoints === 1
                && userAgent.indexOf('Mobile') === -1
            ) {
                $('html').addClass('is-emulation');
            } else {
                $('html').removeClass('is-emulation');
            }
            if (
                (html.hasClass('is-mac')
                    || html.hasClass('is-ios')
                    || html.hasClass('is-android'))
                && navigator.maxTouchPoints
                && navigator.maxTouchPoints >= 1
            ) {
                $('html').addClass('is-touchable');
            } else {
                $('html').removeClass('is-touchable');
            }

            // Media
            if ($(window).width() < mobileBreak) {
                if (window.screen.width < mobileXSBreak) {
                    viewport.setAttribute(
                        'content',
                        'width=' + mobileXSBreak + ', user-scalable=0'
                    );
                } else {
                    viewport.setAttribute(
                        'content',
                        'width=device-width, initial-scale=1'
                    );
                }
                $('html').removeClass('is-desktop is-tablet');
                $('html').addClass('is-mobile');
            } else {
                $('html').addClass('is-desktop');
                if (
                    (window.screen.width >= mobileBreak
                        && window.screen.width <= tabletBreak)
                    || (window.screen.width < mobileBreak
                        && window.screen.height >= mobileBreak
                        && !orientation)
                ) {
                    $('html').addClass('is-tablet');
                    viewport.setAttribute(
                        'content',
                        'width=' + tabletBreak + ', user-scalable=0'
                    );
                } else {
                    $('html').removeClass('is-tablet');
                    viewport.setAttribute(
                        'content',
                        'width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=0'
                    );
                }
                $('html').removeClass('is-mobile');
            }
        }
        $(window).on('load resize', function onLoadWindow() {
            init();
        });
        init();
    }

    // Helper functions

    function isMobile() {
        return $('html').hasClass('is-mobile');
    }

    function isTouchable() {
        return $('html').hasClass('is-touchable');
    }

    function isOutsideOfElement(event, target) {
        var container = $(target);
        if (
            !container.is(event.target)
            && container.has(event.target).length === 0
        ) {
            return true;
        }
        return false;
    }

    function scrollFix(target) {
        var windowScrollLeft = $(window).scrollLeft();
        if (windowScrollLeft > 0 && $(target).css('position') === 'fixed') {
            $(target).css('left', -windowScrollLeft + 'px');
        } else {
            $(target).css('left', 0);
        }
    }

    function scrollLeft() {
        if (!$('.js-scroll-left').length) return;
        $(window).on('load scroll resize', function onLoadWindow() {
            var winLeft = $(window).scrollLeft();
            $('.js-scroll-left').css('left', -winLeft + 'px');
        });
    }

    function frozeWindow(isDo, exception) {
        var classFrozenWindows = 'is-frozen-windows';
        var classFrozenOS = 'is-frozen-os';
        function freezeWindows() {
            if (isDo) {
                offsetY = $(window).scrollTop();
                $('body').css({ top: -offsetY + 'px', left: -offsetX + 'px' });
                $('html').addClass(classFrozenWindows);
                isWindowFrozen = true;
            } else {
                isWindowFrozen = false;
                $('html').removeClass(classFrozenWindows);
                $('body').css({ top: 'auto', left: 'auto' });
                $(window).scrollLeft(offsetX);
                $(window).scrollTop(offsetY);
            }
        }
        function freezeOS() {
            function preventEvent(event) {
                var exceptionDOM = $(exception);
                if (isDo && $('html').hasClass(classFrozenOS)) {
                    if (!exception) {
                        event.preventDefault();
                    } else if (
                        !exceptionDOM.length
                        || isOutsideOfElement(event, exceptionDOM)
                    ) {
                        event.preventDefault();
                    }
                }
            }
            if (isDo) {
                isWindowFrozen = true;
                $('html').addClass(classFrozenOS);
                document.body.addEventListener('touchmove', preventEvent, {
                    passive: false
                });
            } else {
                isWindowFrozen = false;
                document.body.removeEventListener('touchmove', preventEvent);
                $('html').removeClass(classFrozenOS);
            }
        }
        if (isDo) {
            if ($('html').hasClass('is-desktop') && !isTouchable()) {
                freezeWindows();
            } else {
                freezeOS();
            }
        } else if (!isDo && $('html').hasClass(classFrozenWindows)) {
            freezeWindows();
        } else if (!isDo && $('html').hasClass(classFrozenOS)) {
            freezeOS();
        }
    }

    // Advance functions

    function headerCommonOpen() {
        var classReady = 'is-ready';
        var classActive = 'is-active';
        var header = $('header');
        var navigationSitemap = header.find('.navigation-header-sitemap');
        var buttonBurger = header.find('.button-header-burger');
        header.addClass(classReady);
        header.addClass(classActive);
        navigationSitemap.addClass(classReady);
        navigationSitemap.addClass(classActive);
        buttonBurger.addClass(classReady);
        buttonBurger.addClass(classActive);
        if (isWindowFrozen === false) {
            frozeWindow(true, '.navigation-header-sitemap');
        }
        isHeaderActive = true;
    }

    function headerCommonClose() {
        var classReady = 'is-ready';
        var classActive = 'is-active';
        var header = $('header');
        var navigationSitemap = header.find('.navigation-header-sitemap');
        var buttonBurger = header.find('.button-header-burger');
        header.addClass(classReady);
        header.removeClass(classActive);
        navigationSitemap.addClass(classReady);
        navigationSitemap.removeClass(classActive);
        buttonBurger.addClass(classReady);
        buttonBurger.removeClass(classActive);
        if (isWindowFrozen === true) {
            frozeWindow(false);
        }
        isHeaderActive = false;
    }

    function headerCommon() {
        var classReady = 'is-ready';
        var classActive = 'is-active';
        var header = $('header');
        var navigationSitemap = header.find('.navigation-header-sitemap');
        var buttonBurger = header.find('.button-header-burger');
        var maskDefault = header.find('.mask-header-default');
        if (!$('header').length) return;
        header.find('a:not([href="#"])').on('click', function onFind() {
            if (isHeaderActive && !isMobile()) {
                headerCommonClose();
            }
        });
        buttonBurger.on('click', function onClickButton() {
            if (!buttonBurger.hasClass(classActive)) {
                headerCommonOpen();
            } else {
                headerCommonClose();
            }
        });
        maskDefault.on('click', function onClickMask() {
            headerCommonClose();
        });
        $(window).on('load scroll resize', function onLoadWindow() {
            scrollFix(header);
            scrollFix(navigationSitemap);
        });
        $(window).on('resize', function onLoadWindow() {
            header.removeClass(classReady);
            navigationSitemap.removeClass(classReady);
            buttonBurger.removeClass(classReady);
        });
        header.addClass(classReady);
        navigationSitemap.addClass(classReady);
        buttonBurger.addClass(classReady);
    }

    function accordionSP() {
        var classReady = 'is-ready';
        var classActive = 'is-active';
        if (!$('.js-accordion-sp').length) return;
        $('.js-accordion-sp').each(function toggleAccordion() {
            var accordion = $(this);
            var accordionToggle = accordion.find('[data-accordion-role="toggle"]');
            var accordionToggleArea = accordionToggle.find(
                '[data-accordion-role="toggle-area"]'
            );
            var accordionTarget = accordion.find('[data-accordion-role="target"]');
            accordionToggle.on('click', function onClickAccordion(event) {
                if (isMobile() && !isOutsideOfElement(event, accordionToggleArea)) {
                    accordion.addClass(classReady);
                    accordionToggle.addClass(classReady);
                    accordionTarget.addClass(classReady);
                    if (!$(this).hasClass(classActive)) {
                        accordionToggle.addClass(classActive);
                        accordionTarget
                            .addClass(classActive)
                            .stop()
                            .slideDown(500, function onSlideDown() {
                                $(this).removeAttr('style');
                            });
                    } else {
                        accordionToggle.removeClass(classActive);
                        accordionTarget.stop().slideUp(500, function onSlideUp() {
                            accordionTarget.removeClass(classActive);
                        });
                    }
                    return false;
                }
                return true;
            });
            $(window).on('resize', function onLoadWindow() {
                accordion.removeClass(classReady);
                accordionToggle.removeClass(classReady);
                accordionTarget.removeClass(classReady);
            });
            accordionTarget
                .not('.' + classActive)
                .stop()
                .slideUp(0);
            accordion.addClass(classReady);
            accordionToggle.addClass(classReady);
            accordionTarget.addClass(classReady);
        });
    }

    function accordionArea() {
        $('.js-button-dropdown').click(function toggleAccordion() {
            $(this)
                .parents('.has-sub')
                .toggleClass('is-active');
            $(this)
                .parents('.has-sub')
                .find('.js-accordion')
                .stop()
                .slideToggle();
            return false;
        });
    }

    function buttonTop() {
        if (!$('.js-button-top').length) return;
        $('.js-button-top').each(function loopButton() {
            var classReady = 'is-ready';
            var classVisible = 'is-visible';
            var classStatic = 'is-static';
            var button = $(this);
            var buttonViewport = button.find('.button-viewport');
            var buttonWrapper = button.find('.button-wrapper');
            function init() {
                var buttonPosition = button.offset().top;
                var scrollPosition = $(document).scrollTop() + $(window).height();
                var startPosition = window.screen.height;
                if (scrollPosition >= startPosition * 1.2) {
                    button.addClass(classVisible);
                } else {
                    button.removeClass(classVisible);
                }
                if (scrollPosition > buttonPosition) {
                    button.addClass(classStatic);
                } else {
                    button.removeClass(classStatic);
                }
                scrollFix(buttonViewport);
                button.addClass(classReady);
            }
            buttonWrapper.on('click', function onClick() {
                $('html, body').animate({ scrollTop: 0 }, 500, 'swing');
            });
            $(window).on('load resize scroll', function onWindow() {
                init();
            });
            init();
        });
    }

    function buttonFixed() {
        if (!$('.js-button-fixed').length) return;
        $('.js-button-fixed').each(function loopButtonFixed() {
            var classReady = 'is-ready';
            var classStatic = 'is-static';
            var button = $(this);
            var buttonViewport = button.find('.button-viewport');
            var windowHeight = $(window).innerHeight();
            var maxWindowHeight = $(window).scrollTop() - button.offset().top;
            function init() {
                var buttonPosition = button.offset().top;
                var scrollPosition = $(document).scrollTop() + $(window).height();
                windowHeight = $(window).innerHeight();
                maxWindowHeight = button.offset().top - $(window).scrollTop();
                if (scrollPosition > buttonPosition) {
                    buttonViewport.height(maxWindowHeight);
                    button.addClass(classStatic);
                } else {
                    buttonViewport.height(windowHeight);
                    button.removeClass(classStatic);
                }
                scrollFix(buttonViewport);
                button.addClass(classReady);
            }
            $(window).on('load resize scroll', function onWindow() {
                init();
            });
            init();
        });
    }

    function smoothScroll() {
        var anchors = $('a[href*="#"]:not([href="#"])');
        var headerHeight = $('header').height();
        var speed = 500;
        var timeout = 0;
        var position = 0;
        function triggerScroll(context) {
            var href = typeof context === 'string'
                ? context
                : '#'
                + $(context)
                    .attr('href')
                    .split('#')[1];
            if (!$(context).hasClass('no-scroll') && $(href).length) {
                if (isHeaderActive) {
                    timeout = 500;
                    headerCommonClose();
                }
                if (isWindowFrozen) {
                    timeout = 500;
                    frozeWindow(false);
                }
                setTimeout(function onTimeout() {
                    if ($(href).find('.js-button-dropdown').length > 0 && $(href).find('.is-active').length == 0) {
                        position = $(href).offset().top - headerHeight * 1.2;
                        $('body, html').animate({ scrollTop: position }, speed, 'swing');
                        $(href).find('.js-button-dropdown')
                            .parents('.has-sub')
                            .toggleClass('is-active');
                        $(href).find('.js-button-dropdown')
                            .parents('.has-sub')
                            .find('.js-accordion')
                            .stop()
                            .slideToggle();
                    }
                    position = $(href).offset().top - headerHeight * 1.2;
                    $('body, html').animate({ scrollTop: position }, speed, 'swing');
                }, timeout);
                return false;
            }
            return true;
        }
        setTimeout(function setTimerHTMLVisibility() {
            window.scroll(0, 0);
            $('html')
                .removeClass('is-loading')
                .addClass('is-visible');
        }, 1);
        if (window.location.hash) {
            window.scroll(0, 0);
            if (
                navigator.userAgent.indexOf('MSIE ') > -1
                || navigator.userAgent.indexOf('Trident/') > -1
            ) {
                timeout = 0;
            } else {
                timeout = 500;
            }
            setTimeout(function setTimerTriggerScroll() {
                triggerScroll(window.location.hash);
            }, timeout);
        }
        anchors.on('click', function onClickAnchor() {
            return triggerScroll(this);
        });
    }

    function sliderDynamic() {
        if (!$('.js-slider-dynamic').length) return;
        $('.js-slider-dynamic').each(function loopSlider() {
            var classReady = 'is-ready';
            var classActive = 'is-active';
            var classAnimationFreeze = 'is-animation-freeze';
            var slider = $(this);
            var sliderViewport = slider.find('.slider-viewport');
            var sliderWrapper = sliderViewport.find('.slider-wrapper');
            var slidesWrapperBefore = sliderWrapper.clone().addClass('is-before');
            var slidesWrapperAfter = sliderWrapper.clone().addClass('is-after');
            var sliderSlide = sliderWrapper.find('.slider-slide');
            var sliderArrowPrevious = slider.find('.slider-arrow.is-previous');
            var sliderArrowNext = slider.find('.slider-arrow.is-next');
            var sliderDot = slider.find('.slider-dot');
            var sliderTotal = sliderSlide.length;
            var sliderIndex = 0;
            var sliderTimeout = null;
            var autoSlideInterval = 3500; // 自動スライド間隔->1001以上で自動スライド実行

            function calculatingPositionDestination(index) {
                var sliderSlideCurrent = sliderSlide.eq(index);
                var slideOffset = sliderSlideCurrent.position().left
                    + sliderSlideCurrent.outerWidth(true, true) / 2;
                var sliderViewportWidthHalf = sliderViewport.outerWidth(true, true) / 2;
                return (
                    sliderViewportWidthHalf
                    - slideOffset
                    - sliderWrapper.outerWidth(true, true)
                );
            }
            function updatePositionNormal() {
                var positionDestination = calculatingPositionDestination(sliderIndex);
                slider.removeClass(classAnimationFreeze);
                sliderWrapper.css(
                    'transform',
                    'translateX(' + positionDestination + 'px)'
                );
                slidesWrapperBefore.css(
                    'transform',
                    'translateX(' + positionDestination + 'px)'
                );
                slidesWrapperAfter.css(
                    'transform',
                    'translateX(' + positionDestination + 'px)'
                );
                sliderDot
                    .find('.dot-item')
                    .removeClass(classActive)
                    .eq(sliderIndex)
                    .addClass(classActive);
            }
            function updatePositionSeamless(direction) {
                var positionDestinationStart;
                slider.addClass(classAnimationFreeze);
                if (direction === true) {
                    positionDestinationStart = calculatingPositionDestination(sliderTotal - 1)
                        + sliderWrapper.outerWidth(true, true);
                } else {
                    positionDestinationStart = calculatingPositionDestination(0)
                        - sliderWrapper.outerWidth(true, true);
                }
                sliderWrapper
                    .add(slidesWrapperBefore)
                    .add(slidesWrapperAfter)
                    .css('transform', 'translateX(' + positionDestinationStart + 'px)');
                sliderTimeout = setTimeout(function timeSlider() {
                    updatePositionNormal();
                    clearTimeout(sliderTimeout);
                    sliderTimeout = null;
                }, 10);
            }

            /* ↓ 自動スライド ↓ */
            function moveNextSlide() {
                if (sliderTimeout !== null) return;
                if (sliderIndex >= sliderTotal - 1) {
                    sliderIndex = 0;
                    updatePositionSeamless(true);
                } else {
                    sliderIndex += 1;
                    updatePositionNormal();
                }
            }
            function startAutoSlide() {
                return setInterval(moveNextSlide, autoSlideInterval);
            }

            if (autoSlideInterval > 1000) startAutoSlide();
            /* ↑ 自動スライド ↑ */

            sliderWrapper.before(slidesWrapperBefore);
            sliderWrapper.after(slidesWrapperAfter);
            sliderSlide.each(function loopSliderSlide(index) {
                var dotItem = $(
                    '<span class="dot-item" data-index="' + index + '"></span>'
                );
                dotItem.on('click', function onClickDot() {
                    if (sliderTimeout !== null) return false;
                    sliderIndex = $(this).data('index');
                    updatePositionNormal();
                    return true;
                });
                sliderDot.append(dotItem);
            });
            sliderArrowNext.on('click', function onClickSlider() {
                if (sliderTimeout !== null) return false;
                if (sliderIndex >= sliderTotal - 1) {
                    sliderIndex = 0;
                    updatePositionSeamless(true);
                } else {
                    sliderIndex += 1;
                    updatePositionNormal();
                }
                return true;
            });
            sliderArrowPrevious.on('click', function onClickSlider() {
                if (sliderTimeout !== null) return false;
                if (sliderIndex <= 0) {
                    sliderIndex = sliderTotal - 1;
                    updatePositionSeamless(false);
                } else {
                    sliderIndex -= 1;
                    updatePositionNormal();
                }
                return true;
            });
            $(window).resize(updatePositionNormal);
            updatePositionNormal();
            slider.addClass(classReady);
        });
    }

    function formAgree() {
        if (!$('.js-agreement').length) return;
        function toggleSubmit() {
            $('.js-button-submit').toggleClass(
                'is-active',
                $('.js-agreement')
                    .find('input')
                    .is(':checked')
            );
        }
        toggleSubmit();
        $('.js-agreement label').on('click', toggleSubmit);
    }

    function accordionSidebar() {
        $('.js-button-accordion').click(function toggleAccordion() {
            $(this)
                .parents('.has-accordion')
                .toggleClass('is-active');
            $(this)
                .parents('.has-accordion')
                .find('.js-accordion')
                .stop()
                .slideToggle();
            return false;
        });
    }

    function toggleClose(ele, className) {
        if (!ele.hasClass(className)) {
            ele.addClass(className);
        } else {
            ele.removeClass(className);
        }
    }

    $(window).on('load scroll resize', function onLoadWindow() {
        offsetX = $(window).scrollLeft();
        if (isWindowFrozen === true) {
            scrollFix($('body'));
        }
    });

    $(window).on('load', function onLoadWindow() {
        window.WebFontConfig = {
            custom: {
                families: [
                    'Zen Kaku Gothic New:n4,n5,n7',
                    'Noto Sans JP:n4,n5,n6,n7,n9',
                    'acumin-pro',
                ],
                urls: [
                    'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;600;700;900&family=Zen+Kaku+Gothic+New:wght@400;500;700&display=swap',
                    'https://use.typekit.net/uci5zlx.css',
                ]
            }
        };
        (function loadFont() {
            var wf = document.createElement('script');
            var s;
            wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
            wf.type = 'text/javascript';
            wf.async = 'true';
            s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(wf, s);
        }());
    });

    $(function init() {
        detectBrowser();
        detectDevice();
        scrollLeft();
        headerCommon();
        accordionSP();
        buttonTop();
        buttonFixed();
        smoothScroll();
        sliderDynamic();
        accordionArea();
        formAgree();
        accordionSidebar();
    });

    /* header / language表示用 */
    $('.select-header-language').on('click', function() {
        toggleClose($('.select-option'), 'is--open');
    })
}());
